export interface LoanOption {
  id: string;
  name: string;
  highlight: string;
  term: string;
  rate: number;
  apr: number;
  monthly: number;
  // Optional: only shown when the pricing source returns a structured value. Never derived client-side.
  cashToClose?: number;
  loanAmount: number;
  points: number;
  pointsLabel: string;
  fit: string;
  recommended?: boolean;
}

export const loanOptions: LoanOption[] = [
  {
    id: 'fixed30',
    name: '30-year fixed',
    highlight: 'Lowest monthly payment',
    term: '30 years',
    rate: 6.375,
    apr: 6.482,
    monthly: 3119,
    cashToClose: 138420,
    loanAmount: 500000,
    points: 0,
    pointsLabel: 'No points',
    fit: 'Predictable payment that never changes. Most borrowers choose this.',
    recommended: true,
  },
  {
    id: 'fixed15',
    name: '15-year fixed',
    highlight: 'Lowest total interest',
    term: '15 years',
    rate: 5.625,
    apr: 5.791,
    monthly: 4118,
    loanAmount: 500000,
    points: 0.5,
    pointsLabel: '0.5 points ($2,500)',
    fit: 'Higher payment, but you own your home in half the time and save about $381k in interest.',
  },
  {
    id: 'credit30',
    name: '30-year fixed with credit',
    highlight: 'Lowest cash to close',
    term: '30 years',
    rate: 6.75,
    apr: 6.801,
    monthly: 3243,
    cashToClose: 133420,
    loanAmount: 500000,
    points: -1,
    pointsLabel: '$5,000 lender credit',
    fit: 'A slightly higher rate in exchange for $5,000 off your closing costs.',
  },
];
